import ThemeProvider from "./ThemeProvider";
import IdleTimerProvider from "./IdleTimerProvider";
import FormStateContextProvider from "./FormStateContextProvider";
import UpscopeProvider from "./UpscopeProvider";
import ReduxProvider from "./ReduxProvider";
import { ProgressBarProvider } from "../context/ProgressBarContext";
import { ProductProvider } from "context/ProductContext";

const Providers = ({ pathname = "", children }) => (
    <ProductProvider>
        <ThemeProvider>
            <ReduxProvider>
                <FormStateContextProvider pathname={pathname}>
                    <ProgressBarProvider>
                        <IdleTimerProvider>
                            <UpscopeProvider>{children}</UpscopeProvider>
                        </IdleTimerProvider>
                    </ProgressBarProvider>
                </FormStateContextProvider>
            </ReduxProvider>
        </ThemeProvider>
    </ProductProvider>
);

export default Providers;
